module.exports = __webpack_public_path__ + "static/img/2.ebf83b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/my/5/2.png
// module id = 8Ajd
// module chunks = 1